const onScroll = function(){
    for(let uid in Event.scrollCbs){
        Event.scrollCbs[uid]();
    }
};

const onResize = function(){
    if(Event.busy)
        return;
    Event.busy = true;
    setTimeout(function(){
        for(let uid in Event.resizeCbs){
            Event.resizeCbs[uid]();
        }
        Event.busy = false;
    }, 100);
};

const onBodyTap = function(e){
    for(let uid in Event.tapCBs){
        Event.tapCBs[uid](e);
    }
};

const Event = {
    tap : function(selector, cb, parent, remove){
        var $item = (parent) ? $(parent) : $(document);
        if(remove)
            $item.off("tap click", selector, cb);
        else
            $item.on("tap click", selector, cb);
    },
    enter : function(selector, cb, parent, remove){
        var $item = (parent) ? $(parent) : $(document);
        let fn = function(e){
            if(e.which == 13) {
                cb(e);
            }
        };
        if(remove)
            $item.off("keypress", selector, fn);
        else
            $item.on("keypress", selector, fn);
    },
    listen : function(selector, type, cb, parent, remove){
        var $item = (parent) ? $(parent) : $(document);
        if(remove)
            $item.off(type, selector, cb);
        else
            $item.on(type, selector, cb);
    },
    elmListen : function($elm, type, cb, remove){
        if(remove)
            $elm.off(type, cb);
        else
            $elm.on(type, cb);
    },
    listenGlobal : function(type, cb, remove){
        if(remove)
            $(document).off(type, cb);
        else
            $(document).on(type, cb);
    },
    dispatch : function(name, data){
        var event = $.Event( name );
        event.eventData = data;
        $(document).trigger(event);
    },
    bodyTap : function(cb, remove){
        if(remove){
            Event.listenGlobal("tap click", cb, remove);
        }
        else{
            setTimeout(function(){
                Event.listenGlobal("tap click", cb, remove);
            }, 0);
        }
    },
    watchBodyTaps : function(uid, cb, remove){
        if(!Event.tapCBs){
            Event.tapCBs = {};
            Event.listenGlobal("tap click", onBodyTap);
        }
        if(!Event.tapCBs[uid]){
            Event.tapCBs[uid] = cb;
        }
        else if(remove){
            delete Event.tapCBs[uid];
            if(Object.keys(Event.tapCBs).length === 0 && Event.tapCBs.constructor === Object){
                delete Event.tapCBs;
                Event.listenGlobal("tap click", onBodyTap, true);
            }
        }
    },
    scroll : function(uid, cb, remove){
        if(!Event.scrollCbs){
            Event.scrollCbs = {};
            Event.listenGlobal("scroll", onScroll);
        }
        if(!Event.scrollCbs[uid]){
            Event.scrollCbs[uid] = cb;
        }
        else if(remove){
            delete Event.scrollCbs[uid];
            if(Object.keys(Event.scrollCbs).length === 0 && Event.scrollCbs.constructor === Object){
                delete Event.scrollCbs;
                Event.listenGlobal("scroll", onScroll, true);
            }
        }
    },
    resize : function(uid, cb, remove){
        if(!Event.resizeCbs){
            Event.resizeCbs = {};
            $(window).on("resize", onResize);
        }
        if(!Event.resizeCbs[uid]){
            Event.resizeCbs[uid] = cb;
        }
        else if(remove){
            delete Event.resizeCbs[uid];
            if(Object.keys(Event.resizeCbs).length === 0 && Event.resizeCbs.constructor === Object){
                delete Event.resizeCbs;
                $(window).off("resize", onResize);
            }
        }
    }
};
module.exports = Event;


// WEBPACK FOOTER //
// ./src/control/util/Event.js